module.exports = __webpack_public_path__ + "img/Hero.6ae27b51.svg";